// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"61":"css/documents","170":"css/app","486":"css/portal"}[chunkId] + ".css";
};